import {create} from 'zustand';
import * as cache from '@eksab/cache';

export const useAuthStore = create<{isLoggedIn: boolean; setLoggedIn: (isLoggedIn: boolean) => void}>((set) => ({
  isLoggedIn: !!cache.getMe(),
  setLoggedIn: (isLoggedIn: boolean) => set({isLoggedIn}),
}));
